import { LoadingIndicator } from 'hem-ui';
import React from 'react';

export const PreOrderLoading = () => (
  <div className="m-4 grid h-[1000vh] grid-cols-6 gap-2 md:m-8 md:grid-cols-12 md:gap-4">
    <p className="col-span-full flex gap-2 text-base text-black-600 md:col-start-4 md:col-end-10">
      <LoadingIndicator />
      Loading…
    </p>
  </div>
);
